// AKA Base Solution
// Version 1.1
//
// Authors: Vinicius Artioli, Catia Melo, Tony Possamai, Chris Muldoon, Josh Winterbottom, Jeremy Basolo,Sam Johnson, Aung Myo Win


import "../scss/styles.scss";

import "jquery";
window.$ = jQuery;

import 'bootstrap';
import '@popperjs/core';

// COMMON
import "./common/header";
import "./common/lazy-videos";
// import "./common/widont"; // to remove widows/orphans

// BLOCKS
import "./blocks/block-cards-image";
import "./blocks/block-cards-news";
import "./blocks/block-carousel-and-text";
import "./blocks/block-cast-and-creative";
import "./blocks/block-gallery-global";
import "./blocks/block-gallery-scroller";
import "./blocks/block-hero-carousel-global";
import "./blocks/block-quote-slider";
import "./blocks/block-tabs";
import "./blocks/block-text-and-thumbnails";
import "./blocks/block-ticket-calendar-carousel";

$(function () {
	$("body").removeClass("loading");
});

// form submission message
jQuery(document).on('gform_confirmation_loaded', function (event, formId) {
	if (formId == 1) {
		console.log('here');

		const intro = document.querySelector(".form-intro");

		if (intro) {
			intro.innerHTML = `
				<h3 class="form-title mb-0 text-uppercase">
					THANK YOU FOR SIGNING UP.
				</h3>
			`;
		}
	}
});
